import type { ShapeContentOverride } from '../../../../api/client';

/** "5-9" / "3" for a [min, max] count range. */
export function rangeText(r: [number, number]) {
  return r[0] === r[1] ? String(r[0]) : `${r[0]}-${r[1]}`;
}

/** The first standard bundle shape a photo/video mix fits (a null range = none of that media). */
export function matchShape(shapes: ShapeContentOverride[], photos: number, videos: number): ShapeContentOverride | null {
  const fits = (r: [number, number] | null, n: number) => (r ? n >= r[0] && n <= r[1] : n === 0);
  return shapes.find((s) => fits(s.shape.photos, photos) && fits(s.shape.videos, videos)) ?? null;
}
